import React from "react";

function Subscribe() {
  return (
    <section id="subscribe">

      <div className="relative bg-gray-100 py-8 p-4">
        <div className="mb-4 text-center heading">
          <h3 className="font-secondaryFont text-4xl capitalize">
            subscribe & get 10% Off
          </h3>
          <span className="font-primaryFont">On Your First Order</span>
        </div>
        <div className="border-[1px] container input-btn-container">
          <input type="text" className="focus:shadow-none p-2 border-none focus:outline-none rounded-none w-[70%]"
         placeholder="Enter email here" />
          <button className="bg-black px-3 p-2 border-none w-[30%] font-primaryFont font-semibold text-white">
            Subscribe
          </button>
        </div>
      </div>
      <div className="flex justify-center items-center m-0 p-0 w-full container">

      <img className="w-[100%]" src="assets/icons/FreeShipping.jpg" alt="" />
      </div>

    </section>
  );
}

export default Subscribe;
